import { useState, useEffect, useRef } from "react";
import TimeExpired from "../assets/timeExpired.svg";
import RemainingTime from "../assets/clock.svg";

const pad = (n) => String(Math.abs(n)).padStart(2, "0");

export function getCountdown(isoDateString) {
  const target = new Date(isoDateString);
  const now = new Date();

  const diff = target.getTime() - now.getTime();

  // Keep the sign, but calculate the duration using absolute value
  const totalSeconds = Math.floor(Math.abs(diff) / 1000);
  const totalHours = Math.floor(totalSeconds / 3600);

  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    totalHours, // total hours ignoring day boundaries, used for the <48h format
    expired: diff <= 0,
    negative: diff < 0,
  };
}

function formatCountdown(countdown) {
  const { days, hours, minutes, seconds, totalHours } = countdown;

  // Less than 48 hours remaining: show as HH:MM:SS (no days, hours can exceed 24)
  if (totalHours < 48) {
    return `${pad(totalHours)}H:${pad(minutes)}M:${pad(seconds)}S`;
  }

  // 48 hours or more: show as DD:HH:MM:SS
  return `${pad(days)}D:${pad(hours)}H:${pad(minutes)}M:${pad(seconds)}S`;
}

export default function InitiateCountdownTimer({ targetDate }) {
  const [countdown, setCountdown] = useState(() => getCountdown(targetDate));

  const intervalRef = useRef(null);

  useEffect(() => {
    // Update immediately when targetDate changes
    setCountdown(getCountdown(targetDate));

    // Update every second
    intervalRef.current = setInterval(() => {
      setCountdown(getCountdown(targetDate));
    }, 1000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [targetDate]);

  return (
    <div
      className={`flex items-center gap-[10px] ${
        countdown.negative ? "text-[#E83D3D]" : ""
      }`}
    >
      <div className="text-xs flex items-center gap-0.5">
        {/* Negative sign */}
        {countdown.negative && <span>-</span>}

        <span>{formatCountdown(countdown)}</span>
      </div>

      <img
        src={countdown.negative ? TimeExpired : RemainingTime}
        alt="clock-icon"
      />
    </div>
  );
}
